export const POSITIONS = {
  before_first_paragraph: 'before_first_paragraph',
  before_second_paragraph: 'before_second_paragraph',
  bottom_of_first_page: 'bottom_of_first_page',
  top_of_second_page: 'top_of_second_page',
  bottom_of_last_page: 'bottom_of_last_page',
  before_second_heading: 'before_second_heading',
  before_third_heading: 'before_third_heading',
  before_fifth_heading: 'before_fifth_heading',
  before_eighth_heading: 'before_eighth_heading',
  before_twelfth_heading: 'before_twelfth_heading',
  before_fifteenth_heading: 'before_fifteenth_heading',
  before_last_heading: 'before_last_heading',
  bottom_of_second_page: 'bottom_of_second_page',
};

export const POSITION_LABELS = {
  [POSITIONS.before_first_paragraph]: '(分割・分割解除)1ページ目の頭',
  [POSITIONS.before_second_paragraph]: '(分割・分割解除)2段落目の前',
  [POSITIONS.bottom_of_first_page]: '(分割)1ページ目最下部',
  [POSITIONS.top_of_second_page]: '(分割)2ページ目最上部',
  [POSITIONS.bottom_of_second_page]: '(分割)2ページ目最下部',
  [POSITIONS.bottom_of_last_page]: '(分割・分割解除)最終ページ最下部',
  [POSITIONS.before_second_heading]: '(分割・分割解除)2つ目の大見出しの前',
  [POSITIONS.before_third_heading]: '(分割・分割解除)3つ目の大見出しの前',
  [POSITIONS.before_fifth_heading]: '(分割・分割解除)6つ目の大見出しの前',
  [POSITIONS.before_eighth_heading]: '(分割・分割解除)9つ目の大見出しの前',
  [POSITIONS.before_twelfth_heading]: '(分割・分割解除)12番目の大見出しの前',
  [POSITIONS.before_fifteenth_heading]: '(分割・分割解除)15番目の大見出しの前',
  [POSITIONS.before_last_heading]: '(分割・分割解除)最終大見出しの前',
};
